import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@/ui/components/icon/Icon';
  import { router } from '@/ui/routes';
  import { storeToRefs } from 'pinia';
  import { useCourseTakeStore } from '@/stores/trainings/courseTake';
  import CourseProgress from '@/ui/components/trainings/courseTake/CourseProgress.vue';
  import ClosePromptModal from '@/ui/components/trainings/courseTake/ClosePromptModal.vue';
  import { useModal } from '@/ui/concerns/modals/useModal';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseTakeNavbar',
  setup(__props) {

  const courseTake = useCourseTakeStore();
  const { course, activeSection, activeSectionIndex, sectionsCount } = storeToRefs(courseTake);

  const [isCloseModalOpen, openModal, closeModal] = useModal();

  const handleLeave = () => {
    closeModal();
    router.push({ name: 'courses' });
  };

return { __sfc: true,courseTake, course, activeSection, activeSectionIndex, sectionsCount, isCloseModalOpen, openModal, closeModal, handleLeave, Icon, CourseProgress, ClosePromptModal }
}

})